import React, { FC } from 'react';
import OscarMark from '../../ai_agent/components/shared/OscarMark';
import { AOPExecution } from '../../types/AOPExecutionTypes';
import { AOP_RUN_STATES, runStateOf } from './utils/AOPExecutionStates';
import { currentStepLabelOf } from './utils/AOPExecutionUtils';

/** Figma sizes Oscar at 29 beside a line of text; this is that line. */
const MARK_SIZE = 29;

/**
 * What Radar is doing with one work order: Oscar, the state, and the detail.
 *
 * Oscar takes his colour from the state through `currentColor`, and beats his
 * wings only while a run is actually going — a logo that moves on its own is a
 * distraction everywhere else, and here it is the thing that says "still
 * running" without a word.
 */
export const AOPRunState: FC<{ execution: AOPExecution; detail?: string | null }> = ({
	execution,
	detail,
}) => {
	const chrome = AOP_RUN_STATES[runStateOf(execution)];
	const said = detail === undefined ? currentStepLabelOf(execution) : detail;

	return (
		<div className={`flex items-center gap-xs ${chrome.textClass}`}>
			<OscarMark size={MARK_SIZE} animation={chrome.isAnimated ? 'flap' : undefined} />
			<span className="bodymedium">{chrome.label}:</span>
			<span className="bodyregular truncate text-character-secondary">
				{said ? said : `Version ${execution.version}`}
			</span>
		</div>
	);
};

export default AOPRunState;
